//
//
//
//
//
//
//
//


if(process.client) {
    window.GMaps = require('gmaps')
}

export default {

    name: 'GoogleMaps',

    props: {
        lat: {
        },
        lng: {
        },
        zoom: {
            type: Number,
            default: 5
        },
        marker: {
            type: Array,
            default: []
        }
    },

    data() {
        return {
            map: null
        }
    },

    async mounted() {

        if(this.$googleApi.isLoaded() === false) {
            await this.$googleApi.load()
        }

        this.initMap()

    },

    methods: {

        initMap() {

            this.map = new GMaps({
                el: this.$refs.map,
                lat: this.lat,
                lng: this.lng,
                zoom: this.zoom
            });

            if(this.marker.length) {
                this.addMarker()
            }

        },

        addMarker() {

            this.marker.forEach((location) => {

                var infoContent;

                if(location.locality != '' && location.locality != null)
                    infoContent = location.locality + ', ' + location.country;
                else
                    infoContent = location.country;

                this.map.addMarker({
                    lat: location.latitude,
                    lng: location.longitude,
                    title: location.locality,
                    details: { 'contactId': location.contactId },
                    infoWindow: {
                        content: infoContent
                    }
                })
            })

            if(this.marker.length > 1) {
                this.map.fitZoom()
            }

        }

    }


}

